// extracted by mini-css-extract-plugin
module.exports = {"admin":"admin_admin__3BCQ6","imgBackground":"admin_imgBackground__DUwLb","menuResponsive":"admin_menuResponsive__2rKif"};